export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    jQuery(document).on('click', '#close-mobile-menu', this.closeMobileMenu);
    jQuery(document).on('click', '#open-mobile-menu', this.openMobileMenu);
    jQuery(document).on('scroll', this.onScroll);
  },
  closeMobileMenu() {
    console.log('close');
    jQuery('.mobile-nav').removeClass('show');
    document.body.classList.remove('stop-scrolling');
  },
  openMobileMenu() {
    console.log('open');
    jQuery('.mobile-nav').addClass('show');
    document.body.classList.add('stop-scrolling');
  },
  onScroll() {
    let scrollPos = $(window).scrollTop();

    if (scrollPos < 50) {
      jQuery('.navbar-container').removeClass('scrolled');
    } else jQuery('.navbar-container').addClass('scrolled');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js